export default __webpack_public_path__ + "static/media/2.8d872a85.jpeg";